"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIM;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _i18nProvider = require("./i18n-provider");

var _i18n = _interopRequireDefault(require("./i18n"));

function getIM(namespace) {
  var _class, _temp;

  const str = _i18n.default.getMessages(namespace);

  return _temp = _class = class I18nMessage extends _react.default.PureComponent {
    constructor(props) {
      super(props);
    }

    render() {
      const {
        id,
        values
      } = this.props;
      return str(id, values);
    }

  }, (0, _defineProperty2.default)(_class, "contextType", _i18nProvider.I18nContext), _temp;
}